<div class="menu">
    <p-accordion [ngClass]="className" >
        <p-accordionTab *ngIf="showSetup" header="{{ 'Menu.Setup' | translate}}" [selected]="selectedTab == 'Setup'">
            <p-fieldset legend="{{ 'Setup.Group.SetupCompany' | translate}}">
                <li *ngFor="let menu of itemsSetup">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
        </p-accordionTab>
        <p-accordionTab *ngIf="showEmployeeInformation" header="{{ 'Menu.EmployeeInformation' | translate}}" [selected]="selectedTab == 'EmployeeInformation'">
            <p-fieldset legend="{{ 'Menu.EmployeeInformation' | translate}}">
                <li *ngFor="let menu of itemsEmployeeInformation">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
        </p-accordionTab>
        <p-accordionTab *ngIf="showTimeKeeping" header="{{ 'Menu.TimeKeeping' | translate}}" [selected]="selectedTab == 'TimeKeeping'">
            <p-fieldset legend="{{ 'Menu.TimeKeeping' | translate}}">
                <li *ngFor="let menu of itemsTimeKeeping">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
        </p-accordionTab>
        <p-accordionTab *ngIf="showSalaryCalculation" header="{{ 'Menu.SalaryCalculation' | translate}}" [selected]="selectedTab == 'SalaryCalculation'">
            <p-fieldset legend="{{ 'Menu.SalaryCalculation' | translate}}">
                <li *ngFor="let menu of itemsSalaryCalculation">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
        </p-accordionTab>
        <p-accordionTab *ngIf="showInsurancesAndOther" header="{{ 'Menu.InsurancesAndOther' | translate}}" [selected]="selectedTab == 'InsurancesAndOther'">
            <p-fieldset legend="{{ 'Menu.InsurancesAndOther' | translate}}">
                <li *ngFor="let menu of itemsInsurancesAndOther">
                    <a (click)="onMenuClick(menu)" [ngClass]="{'active': selectedItem == menu.Label}">
                        <i class="fa fa-fw" [ngClass]="menu.Icon"></i>
                        {{menu.Label | translate}}
                        <i class="fa right" *ngIf="menu.Childs != null"
                            [ngClass]="{'fa-angle-down': !menu.IsChildVisible,'fa-angle-up': menu.IsChildVisible }"></i>
                    </a>
                </li>
            </p-fieldset>
        </p-accordionTab>
    </p-accordion>
</div>